import script from "./DepartmentListCard.vue?vue&type=script&setup=true&lang=js"
export * from "./DepartmentListCard.vue?vue&type=script&setup=true&lang=js"

import "./DepartmentListCard.vue?vue&type=style&index=0&id=5cbcd0d8&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cbcd0d8"]])

export default __exports__